const PLAIN_NUMBER_INPUT_SELECTOR = [
  ".products-page input[type='number']",
  ".delivery-prices-page input[type='number']",
  ".inventory-page input[type='number']",
  ".promotions-page input[type='number']",
  ".wholesale-page input[type='number']",
].join(", ");

/** Prevent scroll wheel from changing focused price/amount number fields. */
export function installPlainNumberInputScrollGuard() {
  if (typeof window === "undefined") return;

  window.addEventListener(
    "wheel",
    (e) => {
      const el = document.activeElement;
      if (el?.matches?.(PLAIN_NUMBER_INPUT_SELECTOR)) {
        e.preventDefault();
      }
    },
    { passive: false, capture: true }
  );
}
